module.exports = __webpack_public_path__ + "img/9788960171145.54b262c3.jpg";